import { SubClauseWithReference } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a SubClauseWithReference.
 *
 * @param obj - The value to check
 * @returns True if the value is a SubClauseWithReference
 */
export const isSubClauseWithReference = (obj: unknown): obj is SubClauseWithReference => {
  if (!isObjectRecord(obj)) return false;
  const objectRecord = obj;
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  // Check id is a non-blank string
  if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;

  // Check subClauseId is a non-blank string
  if (typeof objectRecord.subClauseId !== "string" || objectRecord.subClauseId === "") return false;

  // Must not have condition property
  if (objectRecord.condition !== undefined) return false;

  // Must not have compoundExpression property
  if (objectRecord.compoundExpression !== undefined) return false;

  return true;
};
